import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "content"];
  static classes = ["active"];

  connect() {
    // Show the first tab by default
    this.showTab("day");
  }

  showTab(period) {
    // Update active tab
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle(this.activeClass, tab.dataset.period === period);
    });

    // Update content based on the selected period
    this.contentTargets.forEach((content) => {
      content.classList.toggle("hidden", content.dataset.period !== period);
    });
  }

  update(event) {
    event.preventDefault();
    const period = event.currentTarget.dataset.period;
    this.showTab(period);
  }
}
